import { FormFieldBase } from './form-field-base';

export class TextAreaField extends FormFieldBase<string> {
    override controlType = 'textarea';
    type: string;

    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] || '';
    }
}
